import { render, staticRenderFns } from "./editaccount.vue?vue&type=template&id=143a93be&scoped=true&"
import script from "./editaccount.vue?vue&type=script&lang=js&"
export * from "./editaccount.vue?vue&type=script&lang=js&"
import style0 from "./editaccount.vue?vue&type=style&index=0&lang=css&"
import style1 from "./editaccount.vue?vue&type=style&index=1&id=143a93be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143a93be",
  null
  
)

export default component.exports